import classNames from "classnames"
import Image from "next/image"
import React from "react"

import { useTranslation } from "@bounce/i18n"
import { Button } from "@bounce/web-components"

import { config } from "../../../config/config"

import background from "./assets/storefront.png"

export type SignupBannerProps = {
  title?: string
  description?: string
  className?: string
}

export const SignupBanner = ({ title, description, className }: SignupBannerProps) => {
  const { t } = useTranslation("marketing-partner")

  return (
    <section className={classNames(className, "relative w-full bg-primary-700")}>
      <div className="mx-auto flex w-full max-w-screen-xl flex-col px-6 md:flex-row md:gap-8 lg:gap-16">
        <div className="mt-16 flex w-full max-w-[680px] flex-col md:my-32">
          <h2 className="title-display text-white">
            {title || t("cmp.partner.signupBanner.titleV3", "Apply to become a Bounce Partner")}
          </h2>
          <p className="subtitle mt-4 text-white md:mt-5 md:max-w-[35ch] xl:max-w-none">
            {description ||
              t(
                "cmp.partner.signupBanner.descriptionV2",
                "Not only do we advertise your business and send extra customers your way. We also pay you for it. Our partners are an essential part of making the Bounce experience sublime.",
              )}
          </p>
          <Button
            href={`${config.apps.partner}/signup/store`}
            rel="nofollow noindex"
            color="white"
            className="mt-7 md:mt-10 xl:mt-12">
            {t("cmp.partner.signupBanner.cta", "Apply now")}
          </Button>
        </div>
        <Image src={background} alt="" loading="lazy" className="my-6 w-full object-contain md:w-1/3 xl:w-1/2" />
      </div>
    </section>
  )
}
